import { Typography } from 'antd'
import YouTube from 'react-youtube'
import styled from 'styled-components'

const VideoWrapper = styled.div`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`

// Two types of URL: https://youtu.be/yg076eXuASU?t=18 or https://www.youtube.com/watch?v=yg076eXuASU or https://www.youtube.com/watch?v=yg076eXuASU&t=18
const getVideoId = (url: string) => {
  const parsedUrl = new URL(url)

  if (url.includes('youtu.be')) {
    // get path with no params
    return parsedUrl.pathname.split('/')[1]
  }

  return parsedUrl.searchParams.get('v')
}

// Get time from video if exists
// https://youtu.be/yg076eXuASU?si=OGcGzHMgsf2saRUJ&t=18
const getTimeFromUrl = (url: string) => {
  if (!url.includes('t=')) {
    return 0
  }

  const parsedUrl = new URL(url)
  const time = parsedUrl.searchParams.get('t')
  return Number(time)
}

export const YoutubeEmbedded = ({
  url,
  caption,
  onWatched,
}: {
  url?: string
  caption?: string
  onWatched?: () => void
}) => {
  // Extract ID from URL
  const videoId = url ? getVideoId(url) : null

  const opts = {
    playerVars: {
      autoplay: 0,
      fs: 0,
      disablekb: 1,
      modestbranding: 1,
      rel: 0,
      start: url ? getTimeFromUrl(url) : 0,
    },
  }

  return (
    videoId && (
      <>
        {caption && <Typography.Paragraph>{caption}</Typography.Paragraph>}
        <VideoWrapper>
          <YouTube videoId={videoId} opts={opts} onEnd={onWatched} />
        </VideoWrapper>
      </>
    )
  )
}
